module.exports = __webpack_public_path__ + "img/screenshot.17773916.png";